module.exports = __webpack_public_path__ + "img/ai.5aac6128.svg";